var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"mei-message-fade"}},[(_vm.show)?_c('div',{class:[
      'mei-message',
      _vm.type? ("mei-message-" + _vm.type) : '']},[_c('span',{staticClass:"mei-message-con"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }